import React, { useEffect, useState } from "react";
import { formatDateTimeToLocal } from "../../../helpers/date";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";
import { Col, Row } from "react-bootstrap";
import SelectObject from "../../ui/SelectObject";

interface ResourcesAssignedTableState {
  data: any;
  showHeader?: boolean;
}

export const ResourcesAssignedTable = ({ data, showHeader = false }: ResourcesAssignedTableState) => {
  const [resourceData, setResourceData] = useState<any[]>([]);
  const [filteredResources, setFilteredResources] = useState<any[]>([]);
  const [selectedType, setSelectedType] = useState<string>();
  const types = [
    { key: "consumable", name: "Consumable" },
    { key: "nonconsumable", name: "Non-Consumable" },
  ];

  const tableHeaders = [
    { label: "Resource ID", key: "resource_id", hide: true },
    { label: "Resource", key: "resource_name" },
    { label: "Category", key: "resource_category" },
    { label: "Quantity", key: "quantity" },
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", hide: true },
    { label: "Name", key: "assignee_name" },
    { label: "Type", key: "resource_type_key_formatted" },
    { label: "Date", key: "assigned_at_formatted" },
  ];

  useEffect(() => {
    if (data) {
      const { resources } = data;
      const grouped = shapeData(resources);
      setResourceData(grouped);
      setFilteredResources(grouped);
    }
  }, [data]);

  const shapeData = (data: any[]) => {
    const grouped = data.reduce(
      (acc, item) => {
        const localDateTime = formatDateTimeToLocal(item.assigned_at);
        const key = `${localDateTime.date}-${item.resource_id}-${item.assignee_id}`;

        if (!acc[key]) {
          acc[key] = {
            ...item,
            resource_type_key_formatted: item.resource_type_key === "nonconsumable" ? "Non-Consumable" : item.resource_type_key,
            assigned_at_formatted: localDateTime.date,
            quantity: 0,
          };
        }

        acc[key].quantity += 1;

        return acc;
      },
      {} as Record<string, any>,
    );

    return Object.values(grouped).sort((a: any, b: any) => new Date(b.assigned_at).getTime() - new Date(a.assigned_at).getTime());
  };

  const updateType = (e: any) => {
    setSelectedType(e.target.value);
    const filtered = resourceData?.filter((r: any) => {
      if (e.target.value === "0") {
        return r;
      } else {
        return r.resource_type_key === e.target.value;
      }
    });

    setFilteredResources(filtered);
  };

  return (
    <>
      {resourceData ? (
        <>
          {showHeader && (
            <Row>
              <Col>
                <h5 className="app-header-text">Resource Assignments</h5>
              </Col>
            </Row>
          )}
          <>
            <Row id="resource-filters">
              <Col xs={4} className="mb-1">
                <SelectObject
                  label="Type"
                  initialOption="View All"
                  value={selectedType}
                  options={types}
                  onUpdate={(e: any) => updateType(e)}
                />
              </Col>
            </Row>
            <DataTable tableHeadings={tableHeaders} tableData={filteredResources} hideTitle={true} hideDownload={true} />
          </>
        </>
      ) : (
        loadingCard()
      )}
    </>
  );
};
